var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterCharges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#1A73E8",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 9.98448C17.103 9.09288 16.2341 8.29001 15.2844 7.59073C15.2003 7.53184 15.1001 7.50024 14.9975 7.50024C14.8949 7.50024 14.7947 7.53184 14.7106 7.59073C13.7627 8.2903 12.8954 9.09316 12.125 9.98448C10.4069 11.9576 9.5 14.0376 9.5 16.0001C9.5 17.4588 10.0795 18.8577 11.1109 19.8892C12.1424 20.9206 13.5413 21.5001 15 21.5001C16.4587 21.5001 17.8576 20.9206 18.8891 19.8892C19.9205 18.8577 20.5 17.4588 20.5 16.0001C20.5 14.0376 19.5931 11.9576 17.875 9.98448ZM15 20.5001C13.8069 20.4988 12.6631 20.0243 11.8195 19.1806C10.9759 18.337 10.5013 17.1932 10.5 16.0001C10.5 12.4232 13.9669 9.4376 15 8.6251C16.0331 9.4376 19.5 12.422 19.5 16.0001C19.4987 17.1932 19.0241 18.337 18.1805 19.1806C17.3369 20.0243 16.1931 20.4988 15 20.5001ZM18.4931 16.5839C18.3635 17.308 18.0151 17.9751 17.4948 18.4953C16.9745 19.0155 16.3073 19.3637 15.5831 19.4932C15.5556 19.4976 15.5278 19.4999 15.5 19.5001C15.3746 19.5001 15.2538 19.4529 15.1615 19.368C15.0692 19.283 15.0122 19.1665 15.0018 19.0415C14.9915 18.9165 15.0284 18.7922 15.1054 18.6932C15.1824 18.5942 15.2938 18.5277 15.4175 18.507C16.4531 18.3326 17.3319 17.4539 17.5075 16.4164C17.5297 16.2856 17.603 16.169 17.7112 16.0922C17.8193 16.0154 17.9536 15.9848 18.0844 16.007C18.2152 16.0292 18.3318 16.1024 18.4085 16.2106C18.4853 16.3188 18.516 16.4531 18.4937 16.5839H18.4931Z",
    fill: "#1A73E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterCharges);
export default __webpack_public_path__ + "static/media/WaterCharges.c5b84644d480cad14274c93af2f9f4fd.svg";
export { ForwardRef as ReactComponent };